import React, { Children } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export function ReservationDetail() {
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 Nov 2025',
      checkOut: '11 Nov 2025',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.my',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Maldivan escape early and enjoy the added luxury of a complimentary round-trip seaplane transfer from Malé to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: '$1.00',
      serviceCharge: '$0.10'
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-3616">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-3617">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-3618">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-3619" />
          <span data-id="element-3620">Reservation Details</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3621">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-3622">
          <div className="flex justify-between items-center" data-id="element-3623">
            <h2 className="text-xl font-bold" data-id="element-3624">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-3625">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-3626">
                Confirmed
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-3627">
                Resend confirmation email
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-3628">
          <div className="p-6 border-r border-gray-200" data-id="element-3629">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-3630">Date</h3>
            <p className="text-gray-900 font-medium" data-id="element-3631">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-3632">
              {reservation.date.nights} Nights
            </p>
          </div>
          <div className="p-6" data-id="element-3633">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-3634">
              Guests & Rooms
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-3635">
              {reservation.guests.adults} Adults, {reservation.guests.children}{' '}
              Children, {reservation.guests.infants} Infants
            </p>
            <p className="text-sm text-gray-500" data-id="element-3636">
              {reservation.guests.rooms} Room
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-3637">
          <h3 className="text-sm font-semibold mb-4" data-id="element-3638">Booking Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3639">
            <div data-id="element-3640">
              <p className="text-sm text-gray-500 mb-1" data-id="element-3641">Booking ID</p>
              <p className="text-sm text-gray-900" data-id="element-3642">{reservation.booking.id}</p>
            </div>
            <div data-id="element-3643">
              <p className="text-sm text-gray-500 mb-1" data-id="element-3644">Transaction ID</p>
              <p className="text-sm text-gray-900" data-id="element-3645">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-3646">
          <h3 className="text-sm font-semibold mb-4" data-id="element-3647">Hotel</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3648">
            <div data-id="element-3649">
              <p className="text-sm text-gray-500 mb-1" data-id="element-3650">Name</p>
              <p className="text-sm text-gray-900" data-id="element-3651">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-3652">
              <p className="text-sm text-gray-500 mb-1" data-id="element-3653">Hotel ID</p>
              <p className="text-sm text-gray-900" data-id="element-3654">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-3655">
          <h3 className="text-sm font-semibold mb-4" data-id="element-3656">Room Type</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3657">
            <div data-id="element-3658">
              <p className="text-sm text-gray-500 mb-1" data-id="element-3659">Name</p>
              <p className="text-sm text-gray-900" data-id="element-3660">{reservation.room.name}</p>
            </div>
            <div data-id="element-3661">
              <p className="text-sm text-gray-500 mb-1" data-id="element-3662">View</p>
              <p className="text-sm text-gray-900" data-id="element-3663">{reservation.room.view}</p>
            </div>
            <div data-id="element-3664">
              <p className="text-sm text-gray-500 mb-1" data-id="element-3665">Category</p>
              <p className="text-sm text-gray-900" data-id="element-3666">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-3667">
          <h3 className="text-sm font-semibold mb-4" data-id="element-3668">Guest Information</h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-3669">
            <h4 className="text-base font-medium mb-4" data-id="element-3670">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3671">
              <div data-id="element-3672">
                <p className="text-sm text-gray-500 mb-1" data-id="element-3673">Email</p>
                <p className="text-sm text-gray-900" data-id="element-3674">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-3675">
                <p className="text-sm text-gray-500 mb-1" data-id="element-3676">Phone number</p>
                <p className="text-sm text-gray-900" data-id="element-3677">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-3678">
                <p className="text-sm text-gray-500 mb-1" data-id="element-3679">Passport number</p>
                <p className="text-sm text-gray-900" data-id="element-3680">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-3681">
                <p className="text-sm text-gray-500 mb-1" data-id="element-3682">Date of birth</p>
                <p className="text-sm text-gray-900" data-id="element-3683">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-3684">
                <p className="text-sm text-gray-500 mb-1" data-id="element-3685">Nationality</p>
                <p className="text-sm text-gray-900" data-id="element-3686">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-3687">
                <p className="text-sm text-gray-500 mb-1" data-id="element-3688">Special Requests</p>
                <p className="text-sm text-gray-900" data-id="element-3689">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-3690">
          <h3 className="text-sm font-semibold mb-4" data-id="element-3691">Rate Details</h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-3692">
            <div data-id="element-3693">
              <p className="text-sm text-gray-500 mb-1" data-id="element-3694">Rate Name</p>
              <p className="text-sm text-gray-900" data-id="element-3695">{reservation.rate.name}</p>
            </div>
            <div data-id="element-3696">
              <p className="text-sm text-gray-500 mb-1" data-id="element-3697">Description</p>
              <p className="text-sm text-gray-900" data-id="element-3698">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-3699">
          <h3 className="text-sm font-semibold mb-4" data-id="element-3700">Price Breakdown</h3>
          <div className="space-y-3" data-id="element-3701">
            <div className="flex justify-between" data-id="element-3702">
              <p className="text-sm text-gray-500" data-id="element-3703">Subtotal</p>
              <p className="text-sm text-gray-900" data-id="element-3704">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-3705">
              <p className="text-sm text-gray-500" data-id="element-3706">Service charge</p>
              <p className="text-sm text-gray-900" data-id="element-3707">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-3708">
              <p className="text-sm font-medium" data-id="element-3709">Total</p>
              <p className="text-sm font-bold" data-id="element-3710">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}